module.exports = __webpack_public_path__ + "static/media/Heater.ee9e3d61.png";